<template>
	<div id="informationDetail">
		<HeaderPC :search="search"></HeaderPC>
		<div class="width1200 nav-box"><router-link to="/informationList">碎片化资料</router-link>  > {{detail.title}} {{detail.description}}</div>
		<div class="width1200 content">
			<div class="left-box">
				<div class="poster-box">
					<img :src="detail.poster_url" alt="" class="poster">
                    <p class="price" v-if="detail.price">￥{{detail.price}}</p>
					<div v-if="detail.is_contact">
						<vue-qr :text="website+'mobile/informationDetail?id='+id" :size="200" class="qrcode"></vue-qr>
						<div class="input-box">
							<input type="text" v-model="form.name">
							<input type="text" v-model="form.phone">
							<input type="text" v-model="form.company">
						</div>
					</div>
				</div>
				<p class="btn btn-download" @click="downloadPoster">点击下载【碎片化资料】原图</p>
				<!-- <a download target="_blank" href="" class="btn btn-download">点击下载【碎片化资料】原图</a> -->
				<a :href="detail.pc_url" class="btn">前往惠普知识树查看</a>
				<div class="qrcode">
					<vue-qr :text="website+'mobile/informationDetail?id='+id" :size="200"></vue-qr>
					<p>扫码使用手机查看</p>
				</div>
			</div>
			<div class="right-box">
				<div class="top-info">
					<div class="img">
						<img :src="detail.image" alt="">
					</div>
					<div class="info">
						<div class="name-box">
							<p class="title">{{detail.title}}</p>
							<p class="description">{{detail.description}}</p>
						</div>
						<!-- <p class="price">预算：￥{{detail.price}}</p> -->
						<!-- <div class="keywords-box">
							<p class="name">速查索引</p>
							<p class="keywords">{{detail.keywords}}</p>
						</div> -->
					</div>
				</div>
				<div class="tabs-nav">
					<p v-for="(item,index) in tabsList" :class="{active:tabsSelected==index}" @click="tabsChange(index)">{{item.name}}</p>
				</div>
				<div class="tabs-con">
					<div :class="'tab-pane '+(tabsSelected==0?'active':'')" v-html="detail.basic_parameters"></div>
					<div :class="'tab-pane sales_case '+(tabsSelected==1?'active':'')">
						<div class="sales_case-list" v-if="!sales_caseDetailShow">
							<div class="box" v-for="(item,index) in detail.sales_case" @click="sales_caseDetailChange(item)">
								<p class="title">{{item.title}}</p>
								<div class="img"><img :src="item.image" alt=""></div>
							</div>
						</div>
						<div class="sales_case-detail" v-html="sales_caseDetail" v-else></div>
					</div>
					<div :class="'tab-pane '+(tabsSelected==2?'active':'')" v-html="detail.main_index"></div>
				</div>
			</div>
		</div>
		<FooterPC></FooterPC>
	</div>
</template>

<script>
export default {
  mounted() {
	  this.id=this.$route.query.id;
	  this.form.url=this.website+'mobile/informationDetail?id='+this.id;
	  this.getdetail();
  },
  data() {
    return {
	  id:"",
	  tabsList:[
		{name:"基本信息"},
		{name:"销售案例"},
		{name:"主要指标"},
	  ],
	  tabsSelected:0,
	  detail:{},
	  sales_caseDetailShow:false,
	  sales_caseDetail:"",
	  
	  sort:"",
	  lists:[],
	  search:"",
	  page:1,
	  links:[],
	  form:{
		  name:window.localStorage.getItem("name"),
		  phone:window.localStorage.getItem("phone"),
		  company:window.localStorage.getItem("company"),
		  url:"",
	  },
    }
  },
  components: {
	  
  },
  methods: {
	  tabsChange(index){
		  this.tabsSelected=index;
		  this.sales_caseDetailShow=false;
	  },
	  getdetail(txt){
		  var t=this;
		  this.fetchGet(`/api/v1/ent/products/`+t.id).then((res) => {
			if(res.code==200){
				this.detail=res.data;
			}
		  })
	  },
	  sales_caseDetailChange(item){
		  this.sales_caseDetailShow=true;
		  this.sales_caseDetail=item.content;
	  },
	  downloadPoster() {
		  var form=this.form;
		  if(this.detail.is_contact==1){
			if(!form.name){
				alert("请填写姓名")
			    return false;
			}
			if(form.name.length>18){
				alert("姓名不能超18个字符")
			    return false;
			}
			if(!(/^1\d{10}$/.test(form.phone))){
			    alert("手机号码有误");
			    return false;
			}
			if(!form.company){
				alert("请填写公司")
			    return false;
			}
			if(form.company.length>18){
				alert("公司不能超18个字符")
			    return false;
			}
		  }
		  window.localStorage.setItem("name",form.name)
		  window.localStorage.setItem("phone",form.phone)
		  window.localStorage.setItem("company",form.company)
		  this.fetchPost(`/api/v1/ent/products/${this.id}/poster`,form).then((res) => {
			if(res.code==200){
				var a=document.createElement("a");
				a.href=res.data.url
				a.setAttribute('download', '');
				a.setAttribute('target', '_blank');
				a.click();
			}
		  })
	  },
  },
}
</script>
<style scoped>
	#informationDetail .nav-box{line-height: 60px;padding: 0 25px;box-sizing: border-box;font-size: 16px;background: #fff;margin-top: 20px;}
	#informationDetail .content{overflow: hidden;padding: 25px;box-sizing: border-box;background: #fff;margin-top: 20px;}
	#informationDetail .left-box{width: 365px;float: left;background: #ECECEC;padding-bottom: 30px;}
	#informationDetail .left-box .poster{width: 100%;display: block;margin-bottom: 22px;}
	
	#informationDetail .left-box .poster-box{position: relative;}
	#informationDetail .left-box .poster-box .price{position: absolute;right: 24px;bottom: 128px;text-align: center;font-size: 19px;color: #0096d6;font-weight: 500;line-height: 24px;width: 108px;font-family: "微软雅黑";}
	#informationDetail .left-box .poster-box .qrcode{position: absolute;bottom: 43.8px;left: 31.6px;width: 66px;height: 66px;}
	#informationDetail .left-box .poster-box .input-box{position: absolute;bottom: 30.66px;right: 36px;width: 173.74px;}
	#informationDetail .left-box .poster-box .input-box input{display: block;margin-top: 6.8px;font-size: 10px;height: 21.4px;width: 100%;border: none;background: none;}
	
	#informationDetail .left-box .btn{display: block;width: 312px;height: 50px;line-height: 50px;background: #0096D6;font-size: 20px;color: #FFFFFF;font-weight: 500;margin: 0 auto 13px;text-align: center;cursor: pointer;}
	#informationDetail .left-box .btn-download{background: #EA3676;}
	#informationDetail .left-box .qrcode{text-align: center;}
	#informationDetail .left-box .qrcode img{width: 136px;height: 136px;}
	#informationDetail .left-box .qrcode p{font-size: 20px;margin-top: 10px;}
	#informationDetail .right-box{float: right;width: 760px;}
	#informationDetail .right-box .top-info{overflow: hidden;}
	#informationDetail .right-box .top-info .img{width: 282px;height: 223px;border: 1px solid #000000;float: left;margin-right: 25px;}
	#informationDetail .right-box .top-info .img img{width: 100%;}
	#informationDetail .right-box .top-info .info{width: 450px;float: left;}
	#informationDetail .right-box .top-info .info .name-box{min-height: 90px;}
	#informationDetail .right-box .top-info .info .title{font-size: 25px;font-weight: bold;line-height: 25px;}
	#informationDetail .right-box .top-info .info .description{font-size: 20px;font-weight: bold;line-height: 20px;margin-top: 11px;}
	#informationDetail .right-box .top-info .info .price{font-size: 25px;font-weight: bold;line-height: 25px;}
	#informationDetail .right-box .top-info .info .keywords-box{margin-top: 36px;}
	#informationDetail .right-box .top-info .info .keywords-box .name{font-size: 20px;font-weight: bold;line-height: 20px;}
	#informationDetail .right-box .top-info .info .keywords-box .keywords{font-size: 18px;line-height: 25px;margin-top: 5px;}
	#informationDetail .right-box .tabs-nav{margin-top: 50px;overflow: hidden;}
	#informationDetail .right-box .tabs-nav p{width: 181px;height: 48px;line-height: 48px;background: #DADADA;font-size: 24px;color: #FFFFFF;text-align: center;float: left;margin-right: 10px;cursor: pointer;}
	#informationDetail .right-box .tabs-nav .active{background: #0096D6;font-weight: 500;}
	#informationDetail .right-box .tabs-con{margin-top: 20px;}
	#informationDetail .right-box .tabs-con .tab-pane{display: none;}
	#informationDetail .right-box .tabs-con .tab-pane.active{display: block;}
	
	
	#informationDetail .right-box .tabs-con .tab-pane{display: none;font-size: 18px;line-height: 22px;}
	#informationDetail .right-box .tabs-con .tab-pane.active{display: block;}
	#informationDetail .right-box .tabs-con .tab-pane>>>img{max-width: 100%;height: auto;}
	#informationDetail .right-box .tabs-con .tab-pane>>>h3{font-size: 20px;}
	#informationDetail .right-box .tabs-con .tab-pane>>> > div,#informationDetail .right-box .tabs-con .tab-pane .sales_case-detail>>> > div{padding-left: 0 !important;padding-right: 0 !important;}
	#informationDetail .right-box .tabs-con .tab-pane>>>.table-box{line-height: 26px;}
	#informationDetail .right-box .tabs-con .tab-pane>>>.table-box div{display: flex;}
	#informationDetail .right-box .tabs-con .tab-pane>>>.table-box div p strong{width: 126px;display: block;}
	#informationDetail .right-box .tabs-con .tab-pane>>>.table-box div p:nth-of-type(1){width: 125px;margin-right: 5px;flex: 0 0 auto;}
	#informationDetail .right-box .tabs-con .tab-pane>>>.table-box div p:nth-of-type(2){width: 100%;}
	
	
	#informationDetail .right-box .tabs-con .sales_case-list{overflow: hidden;}
	#informationDetail .right-box .tabs-con .sales_case-list .box{width: 366px;height: 211px;border: 1px solid #000000;float: left;margin-right: 28px;box-sizing: border-box;cursor: pointer;}
	#informationDetail .right-box .tabs-con .sales_case-list .box:nth-child(2n){margin-right: 0;}
	#informationDetail .right-box .tabs-con .sales_case-list .box p{padding: 0 20px;line-height: 42px;font-size: 16px;font-weight: 500;}
	#informationDetail .right-box .tabs-con .sales_case-list .box .img{width: 100%;height: 169px;overflow: hidden;}
	#informationDetail .right-box .tabs-con .sales_case-list .box .img img{width: 100%;}
	
</style>